module.exports = __webpack_public_path__ + "img/honey-carrot.9e2936f6.jpg";